<template>
  <div class="soar-container flex flex-col pt-6 gap-y-12">
    <div
      class="flex flex-col lg:flex-row justify-start lg:justify-between items-start lg:items-center gap-4"
    >
      <HeaderTypo>{{ $t('smartservice') }}</HeaderTypo>
      <div class="w-full flex-1 flex justify-center items-center">
        <div class="w-full relative border border-brand-grayblue-300 h-full flex rounded-md">
          <input
            :placeholder="$t('publicServiceSearch')"
            type="text"
            class="w-full py-1 ps-3 rounded-s-md bg-white rounded-md placeholder:text-xs"
            v-model="searchValue"
          />
          <div
            class="absolute top-0 end-0 h-full aspect-square bg-brand-gray-300 rounded-e-md p-2.5"
          >
            <faMagnifyingGlass class="" />
          </div>
        </div>
      </div>
      <div
        class="flex-1 md:flex-initial w-full md:w-[unset] flex flex-col md:flex-row gap-2 justify-end items-stretch md:items-center"
      >
        <RouterLink
          to="/establishment-inquiry"
          class="rounded-full bg-primary px-2 py-1.5 text-white text-center hover:bg-primary-700 text-sm"
        >
          {{ $t('establishmentInquiry') }}
        </RouterLink>
        <RouterLink
          to="/file-validity"
          class="rounded-full bg-primary px-2 py-1.5 text-white text-center hover:bg-primary-700 text-sm"
        >
          {{ $t('fileValiditymenu') }}
        </RouterLink>
        <RouterLink
          :to="{ name: 'PublicServicesApplicationTracking' }"
          class="rounded-full bg-primary px-2 py-1.5 text-white text-center hover:bg-primary-700 text-sm"
        >
          {{ $t('applicationTracking') }}
        </RouterLink>
      </div>
    </div>
    <div
      :key="languageCode"
      class="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
    >
      <template :key="key" v-for="(category, key) in filteredCategories">
        <router-link
          :to="{
            name: 'ServicesGrid',
            params: {
              category: category.slug
            },
            query: $route.query
          }"
          class="p-4 max-h-max flex flex-col gap-y-6 justify-center items-center border border-gray-200 dark:border-gray-500 bg-white dark:bg-slate-700 rounded-xl aspect-video lg:aspect-square hover:scale-105 relative"
        >
          <div class="rounded-full bg-primary/10 w-32 h-32 flex justify-center items-center">
            <i
              :class="category.categoryConfig.iconClass"
              class="text-primary-color text-[3rem] text-primary-700"
            />
          </div>
          <span class="text-center">
            {{ category.publicCategoryDesc }}
          </span>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg'
import useLanguageCode from '@/composables/useLanguageCode'
import { usePublicServicesStore } from '@/stores/public_services'
import Fuse from 'fuse.js'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const publicServicesStore = usePublicServicesStore()
const languageCode = useLanguageCode()
const route = useRoute()
const router = useRouter()

const fuse = ref()
const searchValue = ref()

onMounted(async () => {
  if ((publicServicesStore.categories ?? []).length === 0) {
    await publicServicesStore.getCategories()
  }

  await nextTick()
  fuse.value = new Fuse(publicServicesStore.categories, {
    threshold: 0.5,
    keys: [
      'publicCategoryDesc',
      {
        name: 'serviceShortName',
        weight: 4
      },
      'servicesTransIds',
      'servicesTransIdsAsString'
    ]
  })

  searchValue.value = route.query.search
})

const filteredCategories = computed(() => {
  if (!searchValue.value?.trim()) {
    return publicServicesStore.categories
  }

  const results = fuse.value.search(searchValue.value)
  return results.map((r) => r.item)
})

watch(searchValue, (s) => {
  router.replace({
    query: {
      search: s
    }
  })
})
</script>

<script>
export default { name: 'PublicservicesView' }
</script>

<style lang="scss" scoped></style>
